import { NewFilter } from '@/types/NewFilter';

export const filters: NewFilter[] = [
	{
		key: 'company',
		name: 'Empresa',
		isMulti: true,
		isDisabled: () => false,
	},
	{
		key: 'generalInformationJobTitle',
		name: 'Função',
		isMulti: true,
		isDisabled: () => false,
	},
	{
		key: 'workStation',
		name: 'Local de Trabalho',
		isMulti: true,
		isDisabled: () => false,
	},
	{
		key: 'training',
		name: 'Treinamento',
		isMulti: true,
		isDisabled: () => false,
	},
];
